



























































































































import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "@/models/WebinarInfo"
import VideoPlayer from "../shared/VideoPlayer.vue"
import IframeVideoPlayer from "../shared/IframeVideoPlayer.vue"
import { EventBus } from "@/event-bus"
import TitleFlagManager from "@/services/TitleFlagManager"
@Component({ components: { VideoPlayer, IframeVideoPlayer } })
export default class Slider extends Vue {
  @Prop({ required: true }) public webinardata!: WebinarInfo
  @Prop({ default: "" }) public custom_gate_prompt!: string
  get track(): HTMLElement {
    return this.$refs.track as HTMLElement
  }
  get isGated(): boolean {
    return this.$root.$data.isGated
  }
  fontSize = 15
  no_ofVideos = 0
  curpos = 0
  width = 900
  timeout = 0
  hovering = false
  isgateOpen = false
  titleManager = new TitleFlagManager()
  titleIndex = 0
  canSlide = true
  created() {
    this.webinardata.moments.forEach(moment => {
      this.titleManager.push(parseInt(moment.id), true)
    })
  }
  mounted() {
    if (this.webinardata.is_full_video_visible) {
      this.no_ofVideos = this.webinardata.moments.length
      this.titleManager.push(-1, true)
    } else {
      this.no_ofVideos = this.webinardata.moments.length - 1
    }
    window.addEventListener("resize", this.handleResize)
    this.width = (this.$refs.aw_container as HTMLElement).clientWidth
    this.fontSize = (26 * 1.2 * this.width) / 800
    this.startTimeout(3000)
    EventBus.$on("gate-event", this.ongateopen)
    EventBus.$on("playing-Video", this.hideTitle)
    EventBus.$on("playing-iframe-Video", this.hideIframeTitle)
    setTimeout(this.init, 500)
  }
  hideTitle(i: number) {
    this.titleManager.edit(i, false)
    this.titleIndex += 1
  }
  hideIframeTitle(i: number) {
    this.canSlide = false
    this.titleManager.edit(i, false)
    this.titleIndex += 1
  }
  ongateopen() {
    this.isgateOpen = true
  }
  ongateclose() {
    this.isgateOpen = false
  }
  iterator() {
    this.stopTimeout()
    this.next()
    this.startTimeout(2500)
  }
  stopTimeout() {
    clearTimeout(this.timeout)
  }
  startTimeout(timeout: number) {
    if (this.isPlaying() || this.isgateOpen || !this.canSlide) return
    this.timeout = setTimeout(() => {
      this.iterator()
    }, timeout)
  }
  init() {
    EventBus.$emit("carouselSetupCompleted")
  }
  next() {
    this.stopAllVideos()
    if (this.curpos < this.no_ofVideos) {
      this.curpos++
    } else {
      this.curpos = 0
    }
    this.track.setAttribute(
      "style",
      `width:${
        this.width * (this.webinardata.moments.length + 1) + 2
      }px !important;transform:translateX(-${
        this.curpos * this.width
      }px) !important;`
    )
  }
  previous() {
    this.stopAllVideos()
    if (this.curpos > 0) {
      this.curpos--
    } else {
      this.curpos = this.no_ofVideos
    }
    this.track.setAttribute(
      "style",
      `width:${
        this.width * (this.webinardata.moments.length + 1) + 2
      }px !important;transform:translateX(-${
        this.curpos * this.width
      }px) !important;`
    )
  }
  stopAllVideos() {
    this.$root.$data.videoPlayers.forEach((element: HTMLVideoElement) => {
      if (!element.paused) element.pause()
    })
  }
  isPlaying(): boolean {
    for (let i = 0; i < this.$root.$data.videoPlayers.length; i++) {
      if (!this.$root.$data.videoPlayers[i].paused) return true
    }
    return false
  }
  handleResize() {
    this.width = (this.$refs.aw_container as HTMLElement).clientWidth
    this.fontSize = (26 * 1.2 * this.width) / 800
  }
}
